"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CheckBoxInput = void 0;
var _react = _interopRequireDefault(require("react"));
var _ui = require("../ui");
var _Input = require("./Input");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var CheckBoxInput = function CheckBoxInput(props) {
  return /*#__PURE__*/_react.default.createElement(_Input.Input, _extends({}, props, {
    inputComponent: _ui.CheckBoxInput
  }));
};
exports.CheckBoxInput = CheckBoxInput;